import { render, staticRenderFns } from "./NPowerBall.vue?vue&type=template&id=5daff665&scoped=true"
import script from "./NPowerBall.vue?vue&type=script&lang=js"
export * from "./NPowerBall.vue?vue&type=script&lang=js"
import style0 from "./NPowerBall.vue?vue&type=style&index=0&id=5daff665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5daff665",
  null
  
)

export default component.exports